import {DomainObject} from 'shared/store';
import {observable, action} from 'mobx';
import {Employee} from 'main/stores/employees';

class MassUpdateSummary extends DomainObject {
  @observable payRate;
  @observable previousPayRate;
  @observable employee;
  @observable errorMessage;
  @observable fields = {};

  @action merge(other) {
    super.merge(other, {
      employee: Employee
    });
  }
}

export default MassUpdateSummary;
